import { createSlice } from '@reduxjs/toolkit';

const serviceDeskSlice = createSlice({
  name: 'serviceDesk',
  initialState: {
    region: [],
    company: [],
  },
  reducers: {
    getRegion: () => {},
    getRegionSuccess: (state, { payload }) => {
      state.region = payload;
    },
    getCompany: () => {},
    getCompanySuccess: (state, { payload }) => {
      const _payload = [...payload];
      let child = [];
      let parentIndex = -1;
      _payload.forEach((item, index) => {
        if (item.sdeskTypeCd === 'COMP') {
          if (parentIndex !== -1) {
            _payload[parentIndex].child = child;
          }
          parentIndex = index;
          child = [];
        } else {
          child.push(item);
        }
      });
      if (parentIndex !== -1 && child.length > 0) {
        _payload[parentIndex].child = child;
      }
      state.company = _payload;
    },
  },
});

export const { getRegion, getRegionSuccess, getCompany, getCompanySuccess } = serviceDeskSlice.actions;
export default serviceDeskSlice.reducer;
